import { render, staticRenderFns } from "./PlanejamentoAcaoFormDetalhesAcao.vue?vue&type=template&id=4c76d788"
import script from "./PlanejamentoAcaoFormDetalhesAcao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormDetalhesAcao.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoFormDetalhesAcao.vue?vue&type=style&index=0&id=4c76d788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports